import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import BatchesRows from './BatchesRows'
import '../../styles/_index.scss'

class BatchProductionStatusTable extends Component {

    render() {
        const { loading, batches, onChangeProductType, handleChangeInput, total_items_without_moved, newFilter, total_items_without_moved_and_completed, total_items_not_shipped} = this.props

        return (
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped BatchProductionStatusTable'>
                    <thead className='thead-light'>

                        <tr>
                            <th className='Name'>Tên lô</th>
                            <th className="colDate">Ngày tạo lô</th>
                            <th className="">Ngày in</th>
                            <th className="">Ngày cắt</th>
                            <th className="">Ngày khắc</th>
                            <th className="">Ngày hoàn thiện</th>
                            <th className="">Loại sản phẩm</th>
                            <th className="">Số lượng ({ newFilter.status === 'completed_without_shipped' ? total_items_not_shipped : (newFilter.status === "completable") ? total_items_without_moved_and_completed : total_items_without_moved} items)</th>
                            <th className="">Thời gian sản xuất</th>
                            <th className="text-center Status">Trạng thái</th>
                            <th className="">Đối tác in</th>
                            <th className="note">Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            batches.length > 0 ? (
                                batches.map(item => {
                                    return (
                                        <BatchesRows
                                            key={item._id} item={item}
                                            handleSendLoading={this._handleSendLoading}
                                            onChangeProductType={onChangeProductType}
                                            handleChangeInput={handleChangeInput}
                                            newFilter={newFilter}
                                        />
                                    )
                                }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={12}>No data</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        )
    }

}

BatchProductionStatusTable.propTypes = {
    batches: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChangeProductType: PropTypes.func
}

export default BatchProductionStatusTable
